import React from "react";

type BoxIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const BoxIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: BoxIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* 3D cube with four corner brackets around it */}
    <path
      d="M3 8 L3 3 L8 3 M16 3 L21 3 L21 8 M3 16 L3 21 L8 21 M16 21 L21 21 L21 16 M12 7 L17 10 L17 15 L12 18 L7 15 L7 10 Z M7 10 L12 13 L17 10 M12 13 L12 18"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BoxIcon;
